import { HttpInterceptorFn } from '@angular/common/http';

/**
 * HTTP interceptor that adds credentials and cache headers to all requests.
 * - withCredentials: true — enables sending cookies cross-origin (Keycloak session)
 * - Cache-Control / Pragma — prevents stale cached responses
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const clonedRequest = req.clone({
    withCredentials: true,
    setHeaders: {
      'Cache-Control': 'no-cache, no-store',
      'Pragma': 'no-cache',
    },
  });
  return next(clonedRequest);
};
